var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import EdsTextField from '@hedtech/react-design-system/core/es/TextField';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = ((theme) => createStyles({
    adornment: {},
    cell: {
        '& > div > input': {
            width: '100%'
        },
        display: 'table-cell!important'
    },
    cellNumeric: {
        [theme.breakpoints.up('md')]: {
            float: 'right'
        }
    },
    colorField: {
        '& > div > input': {
            height: Tokens.sizingXLarge,
            padding: 0,
            width: Tokens.sizingXLarge
        }
    },
    fileField: {
        '& > div > input': {
            height: Tokens.sizingXLarge,
            padding: 0
        }
    },
    inputMultiline: {},
    numeric: {
        '& > div > input': {
            textAlign: 'right'
        }
    },
    root: {}
}));
const TextField = (props) => {
    const { cell, classes, numeric, type } = props, rest = __rest(props, ["cell", "classes", "numeric", "type"]);
    const classOverrides = omit(classes, ['cell', 'cellNumeric', 'colorField', 'fileField', 'numeric', 'smallField']);
    if (cell) {
        classOverrides.root = classnames(classOverrides.root, classes.cell);
    }
    if (numeric) {
        classOverrides.root = classnames(classOverrides.root, classes.numeric);
    }
    if (cell && numeric) {
        classOverrides.root = classnames(classOverrides.root, classes.cellNumeric);
    }
    if (type === 'color') {
        classOverrides.root = classnames(classOverrides.root, classes.colorField);
    }
    if (type === 'file') {
        classOverrides.root = classnames(classOverrides.root, classes.fileField);
    }
    return (React.createElement(EdsTextField, Object.assign({ classes: classOverrides, type: type }, rest)));
};
TextField.defaultProps = {
    cell: false,
    fullWidth: true,
    id: '',
    margin: 'normal',
    numeric: false
};
const TextFieldWithStyles = withStyles(styles)(TextField);
export default TextFieldWithStyles;
